import React from 'react'
import CompleteIcon from '../CompleteIcon/CompleteIcon';
import styles from './CompleteModal.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);
const CompleteModal = ({
  onClick,
  isClosed,
  text
}) => {
  return (
    <div onClick={onClick} className={cx('CompleteModal', isClosed && 'CompleteModal--closed')}>
        <div className={cx('CompleteModal__modal')}>
          <span className={cx('CompleteModal__modal-icon')}>
            <CompleteIcon style={{ width: '54px', height: '54px' }} />
          </span>
          <span className={cx('CompleteModal__modal-message')}>{text}</span>
        </div>
      </div>
  );
};



export default CompleteModal;



// WEBPACK FOOTER //
// ./src/app/thermostats/components/CompleteModal/CompleteModal.js